const filterPlansSelect = function (checked, planSelector) {
    const cycle = checked ? 'yearly' : 'monthly';
    const plans = document.querySelectorAll(planSelector);

    plans.forEach((pricingCard) => {
        if (pricingCard.dataset.cycle !== cycle) {
            pricingCard.classList.add("u-display-none")
        } else {
            pricingCard.classList.remove("u-display-none");
        }
    });
};

const planCycle = () => {
    let planSwitchers = document.querySelectorAll(':not(.registration-form__right) > .plans-switcher input[type="checkbox"]');

    planSwitchers[0].addEventListener("change", (event) => {
        filterPlansSelect(event.target.checked, '.cards-pricing__list .pricing-card');
    });

    planSwitchers[1].addEventListener("change", (event) => {
        filterPlansSelect(event.target.checked, '.features-table .plan-card');
    });
};

export default {planCycleListener: planCycle, filterPlansSelect};